import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";

export const teamMenuResolver: ResolveFn<{ menuId: string | null }> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const menuId: string = 'team-menu';
    return { menuId };
  };
